import React from "react";
import { Box } from "@mui/material";

const BlobWrapper = ({ src }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: { xs: "12rem", sm: "20rem" }, // smaller on mobile
        height: { xs: "12rem", sm: "20rem" },
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "white",
          borderRadius: "50% 40% 60% 50% / 60% 70% 40% 70%",
          boxShadow: "0 0 15px rgba(255,255,255,0.15)",
          position: "absolute",
          zIndex: 1,
          filter: "blur(0.4px)",
        }}
      />

      <Box
        component="img"
        src={src}
        alt="SVG Graphic"
        sx={{
          position: "absolute",
          width: { xs: "150%", sm: "130%" }, // scale proportionally
          top: { xs: "-2rem", sm: "-3rem" },
          left: { xs: "0", sm: "-5rem" },
          right: { xs: "0", sm: "auto" },
          margin: { xs: "0 auto", sm: "initial" },
          zIndex: 2,
          objectFit: "contain",
        }}
      />
    </Box>
  );
};

export default BlobWrapper;
